import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux'; // Connecting to Redux
import { Layout, Row, Col } from 'antd';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { MissionState } from "src/redux/CheckpointReducer";
import { UserState } from "src/redux/UserReducer";
import GeneralHeader from "src/layouts/GeneralHeader";

const { Header, Footer, Sider, Content } = Layout;

interface SpaceStationLayoutProps {
    missionStatus: MissionState;
    userStatus: UserState;
}

class SpaceStationLayout extends React.Component<SpaceStationLayoutProps> {
    constructor(props: SpaceStationLayoutProps) {
        super(props);
        bindAllOfThis(this, SpaceStationLayout.prototype);
    }

    public render() {
        return <Layout className="space-station" style={{ height: '100vh' }}>
            <GeneralHeader
                renderEmulationBanner={false}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={true}
                renderPlanetBox={true}
                renderBackToSpaceStation={false}
            />
            <Content>
                {this.props.children}
            </Content>
        </Layout>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        missionStatus: state.Mission,
        userStatus: state.User
    };
}

export default connect(mapStateToProps)(SpaceStationLayout);



// WEBPACK FOOTER //
// ./src/layouts/spacestation/SpaceStationLayout.tsx